import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { v4 as uuidv4 } from 'uuid';
import {Link, useNavigate, useLocation} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { useAuth } from '../../hooks/useAuth';
import LoginOverlay from '../Authorization/LoginOverlay';

function NavBar({logout, setTheId}) {
    const location = useLocation();
    const { isAuthenticated } = useAuth();
    const [showLoginOverlay, setShowLoginOverlay] = useState(false);


    const onLogout = () => {
        // Use the logout function from useAuth hook
        logout();
    }

    const uuid = useRef(uuidv4());

    // Always show Dashboard - authentication only affects submissions
    const pages = isAuthenticated 
        ? ["Dashboard", "DSA", "LLD", "HLD", "Deep Dives", "Smart Notes"] 
        : ["Dashboard", "DSA", "LLD", "HLD", "Deep Dives", "Smart Notes", "Login"];
    const settings = isAuthenticated ? ["Profile", "Logout"] : ["Login"];

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
        setTheId(uuid.current);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const [anchorElNav_notify, setAnchorElNav_notify] = React.useState(null);
    const [anchorElUser_notify, setAnchorElUser_notify] = React.useState(null);

    const handleOpenNavMenu_notify = (event) => {
        setAnchorElNav_notify(event.currentTarget);
    };
    const handleOpenUserMenu_notify = (event) => {
        setAnchorElUser_notify(event.currentTarget);
    };

    const handleCloseNavMenu_notify = () => {
        setAnchorElNav_notify(null);
    };

    const handleCloseUserMenu_notify = () => {
        setAnchorElNav_notify(null);
        setTheId(uuid.current);
    };


    // Function to check if a route is active
    const isActiveRoute = (routePath) => {
        const currentPath = location.pathname;
        
        // Handle exact path matching
        if (routePath === 'dashboard') {
            return currentPath === '/dashboard';
        }
        if (routePath === 'session-details') {
            return currentPath === '/session-details';
        }
        if (routePath === 'problem-details') {
            return currentPath === '/problem-details';
        }
        if (routePath === 'dsa') {
            return currentPath === '/dsa' || currentPath.startsWith('/dsa/');
        }
        if (routePath === 'lld') {
            return currentPath === '/lld' || currentPath.startsWith('/lld/');
        }
        if (routePath === 'hld') {
            return currentPath === '/hld' || currentPath.startsWith('/hld/');
        }
        if (routePath === 'deep-dives') {
            return currentPath === '/deep-dives' || currentPath.startsWith('/deep-dives/');
        }
        if (routePath === 'applications') {
            return currentPath === '/applications' || currentPath === '/subApplications' || currentPath === '/microservices' || currentPath === '/problem';
        }
        if (routePath === 'myNotes') {
            return currentPath === '/myNotes';
        }
        if (routePath === 'hackathon') {
            return currentPath === '/hackathon';
        }
        if (routePath === 'login') {
            return false; // Login tab should never be highlighted as active
        }
        
        return currentPath === `/${routePath}`;
    };

    return (
        <>
        <div style={{width: "100vw"}}>
            <AppBar position="static" style={{backgroundColor: "pink"}}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <img
                            src={"/images/slazysloth.png"}
                            alt="slazysloth"
                            style={{height: "50px", width: "160px",cursor:"pointer"}}
                            onClick={()=>{window.location.href = '/'}}
                        />

                        <Box
                            sx={{
                                flexGrow: 1,
                                display: {xs: "flex", md: "none"},
                                paddingRight: "20px",
                                alignItems: "center",
                                justifyContent: "flex-end",
                            }}
                        >
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="black"
                            >
                                <MenuIcon/>
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: {xs: "block", md: "none"},
                                }}
                            >
                                {pages.map((page, index) => {
                                    // Handle Login tab differently for mobile
                                    if (page === "Login") {
                                        return (
                                            <MenuItem 
                                                key={page}
                                                onClick={() => {
                                                    setShowLoginOverlay(true);
                                                    handleCloseUserMenu_notify();
                                                }}
                                            >
                                                <Typography textAlign="center"
                                                            sx={{
                                                    color: "#ffffff",
                                                    display: "block",
                                                    fontWeight: 700,
                                                    letterSpacing: "0.5px",
                                                    textTransform: "uppercase",
                                                    background:
                                                        "linear-gradient(135deg, #008080 0%, #00a3a3 100%)",
                                                    borderRadius: "999px",
                                                    padding: "6px 18px",
                                                    boxShadow:
                                                        "0 3px 10px rgba(0, 128, 128, 0.4)",
                                                    "@keyframes navLoginBlinkMobile": {
                                                        "0%, 100%": { opacity: 1 },
                                                        "50%": { opacity: 0.78 },
                                                    },
                                                    animation:
                                                        "navLoginBlinkMobile 2.4s ease-in-out infinite",
                                                    "@media (prefers-reduced-motion: reduce)": {
                                                        animation: "none",
                                                    },
                                                }}>
                                                    {page}
                                                </Typography>
                                            </MenuItem>
                                        );
                                    }
                                    
                                    // Regular navigation for other tabs
                                    // Find the correct link for this page
                                    const pageToLinkMap = {
                                        'Dashboard': 'dashboard',
                                        'DSA': 'dsa', 
                                        'LLD': 'lld',
                                        'HLD': 'hld',
                                        'Deep Dives': 'deep-dives',
                                        'Smart Notes': 'myNotes'
                                    };
                                    const linkPath = pageToLinkMap[page] || 'dashboard';
                                    
                                    return (
                                        <Link to={linkPath} key={page}>
                                            <MenuItem onClick={handleCloseUserMenu_notify}>
                                                <Typography textAlign="center"
                                                            sx={{
                                                    color: isActiveRoute(linkPath) ? "#008080" : "black",
                                                    display: "block",
                                                    fontWeight: "bold",
                                                    backgroundColor: isActiveRoute(linkPath) ? "rgba(0, 128, 128, 0.1)" : "transparent",
                                                    borderRadius: "4px",
                                                    padding: "4px 8px",
                                                }} onClick={() => {
                                                }}>
                                                    {page}
                                                </Typography>
                                            </MenuItem>
                                        </Link>
                                    );
                                })}
                            </Menu>
                        </Box>

                        <Box
                            sx={{
                                flexGrow: 1,
                                paddingRight: "20px",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                display: {xs: "none", md: "flex"},
                            }}
                        >
                            {/* Discord Icon - Left of DSA Session */}
                            <Box sx={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                                <Tooltip title="Join our Discord Community">
                                    <IconButton
                                        onClick={() => window.open('https://discord.gg/bW7zF36Sa6', '_blank')}
                                        sx={{
                                            color: '#5865F2', // Discord brand color
                                            '&:hover': {
                                                backgroundColor: 'rgba(88, 101, 242, 0.1)',
                                                transform: 'scale(1.1)',
                                            },
                                            transition: 'all 0.2s ease-in-out',
                                        }}
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                        >
                                            <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.019 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1568 2.4189Z"/>
                                        </svg>
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            {pages.map((page,index) => {
                                // Handle Login tab differently — render as a
                                // prominent, blinking CTA distinct from the
                                // regular nav links.
                                if (page === "Login") {
                                    return (
                                        <Button
                                            key={page}
                                            disableRipple={false}
                                            onClick={() => {
                                                setShowLoginOverlay(true);
                                                handleCloseNavMenu();
                                            }}
                                            sx={{
                                                my: 2,
                                                ml: 1.5,
                                                color: "#ffffff",
                                                display: "block",
                                                fontWeight: 700,
                                                letterSpacing: "0.5px",
                                                textTransform: "uppercase",
                                                fontSize: "0.85rem",
                                                background:
                                                    "linear-gradient(135deg, #008080 0%, #00a3a3 100%)",
                                                border: "1.5px solid rgba(255,255,255,0.6)",
                                                borderRadius: "999px",
                                                padding: "8px 22px",
                                                boxShadow:
                                                    "0 4px 14px rgba(0, 128, 128, 0.45)",
                                                position: "relative",
                                                overflow: "visible",
                                                "@keyframes navLoginPulse": {
                                                    "0%": {
                                                        boxShadow:
                                                            "0 4px 14px rgba(0, 128, 128, 0.45), 0 0 0 0 rgba(0, 163, 163, 0.65)",
                                                    },
                                                    "55%": {
                                                        boxShadow:
                                                            "0 4px 14px rgba(0, 128, 128, 0.45), 0 0 0 12px rgba(0, 163, 163, 0)",
                                                    },
                                                    "100%": {
                                                        boxShadow:
                                                            "0 4px 14px rgba(0, 128, 128, 0.45), 0 0 0 0 rgba(0, 163, 163, 0)",
                                                    },
                                                },
                                                "@keyframes navLoginBlink": {
                                                    "0%, 100%": { opacity: 1 },
                                                    "50%": { opacity: 0.78 },
                                                },
                                                animation:
                                                    "navLoginPulse 1.8s ease-out infinite, navLoginBlink 2.4s ease-in-out infinite",
                                                transition:
                                                    "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease",
                                                '&:hover': {
                                                    background:
                                                        "linear-gradient(135deg, #006666 0%, #008b8b 100%)",
                                                    transform: "translateY(-1px) scale(1.03)",
                                                    animationPlayState: "paused",
                                                    boxShadow:
                                                        "0 6px 20px rgba(0, 128, 128, 0.6)",
                                                },
                                                '&:active': {
                                                    transform: "translateY(0) scale(0.98)",
                                                    boxShadow:
                                                        "0 2px 8px rgba(0, 128, 128, 0.5)",
                                                },
                                                "@media (prefers-reduced-motion: reduce)": {
                                                    animation: "none",
                                                },
                                            }}
                                        >
                                            {page}
                                        </Button>
                                    );
                                }
                                
                                // Regular navigation for other tabs
                                // Find the correct link for this page
                                const pageToLinkMap = {
                                    'Dashboard': 'dashboard',
                                    'DSA': 'dsa', 
                                    'LLD': 'lld',
                                    'HLD': 'hld',
                                    'Deep Dives': 'deep-dives',
                                    'Smart Notes': 'myNotes'
                                };
                                const linkPath = pageToLinkMap[page] || 'dashboard';
                                
                                return (
                                    <Link to={linkPath} key={page}>
                                        <Button
                                            onClick={handleCloseNavMenu}
                                            sx={{
                                                my: 2,
                                                color: isActiveRoute(linkPath) ? "#008080" : "black",
                                                display: "block",
                                                fontWeight: "bold",
                                                backgroundColor: isActiveRoute(linkPath) ? "rgba(0, 128, 128, 0.1)" : "transparent",
                                                borderRadius: "8px",
                                                padding: "8px 16px",
                                                '&:hover': {
                                                    backgroundColor: isActiveRoute(linkPath) ? "rgba(0, 128, 128, 0.2)" : "rgba(0, 0, 0, 0.1)",
                                                },
                                                transition: "all 0.2s ease-in-out",
                                            }}
                                        >
                                            {page}
                                        </Button>
                                    </Link>
                                );
                            })}
                        </Box>

                        <Box sx={{flexGrow: 0}}>
                            <Tooltip title="Profile">
                                <IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                                    <Avatar
                                        alt="Remy Sharp"
                                        src="/images/logo_without_background.png"
                                    />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{mt: "45px"}}
                                style={{position: "absolute"}}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                {settings.map((setting, index) => {
                                    if (isAuthenticated) {
                                        return (
                                            <Link
                                                key={setting}
                                                to={index === 0 ? "/profile" : "/"}
                                                onClick={index === 1 ? () => onLogout() : null}
                                            >
                                                <MenuItem onClick={handleCloseUserMenu}>
                                                    <Typography
                                                        textAlign="center"
                                                        style={{color: "#008080"}}
                                                    >
                                                        {setting}
                                                    </Typography>
                                                </MenuItem>
                                            </Link>
                                        );
                                    } else {
                                        return (
                                            <MenuItem 
                                                key={setting}
                                                onClick={() => {
                                                    setShowLoginOverlay(true);
                                                    handleCloseUserMenu();
                                                }}
                                            >
                                                <Typography
                                                    textAlign="center"
                                                    style={{color: "#008080"}}
                                                >
                                                    {setting}
                                                </Typography>
                                            </MenuItem>
                                        );
                                    }
                                })}
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
        {showLoginOverlay && (
            <LoginOverlay onClose={() => setShowLoginOverlay(false)} />
        )}
        </>
    );
}

export default NavBar;
